import React from 'react'

import Product from '../Products/Product'

export const popularDish = (props) => {
  return (
    <div className={props.checkout ? 'list-items cart-open' : 'list-items'}>
      {props.popularDishItems.map(item =>
        (
          props.restaurantsOptions[0].active === true ?
            <Product
              isPopularDish={true}
              key={item.product.id+item.business.name+item.business.id}
              product={item.product}
              business={item.business}
              selectProduct={props.selectProduct} /> :
            item.product.forCollection ?
              <Product
                key={item.product.id}
                product={item.product}
                selectProduct={props.selectProduct} /> :
              null
        ))}
      <div className='cart-menu-category-overlay'></div>
    </div>
  )
}

export default popularDish



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/PopularDish/index.js